import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../Datas/siteConfig";
import "../css/about.scss";

const studioValues = [
  {
    number: "01",
    title: "Made by hand",
    text: "Every motif begins away from the screen, with brushes, pigments and the small irregularities that make a piece feel alive.",
  },
  {
    number: "02",
    title: "Made in small editions",
    text: "We work slowly and in considered quantities, choosing lasting materials and keeping the people behind each object close to the process.",
  },
  {
    number: "03",
    title: "Made for everyday wonder",
    text: "Colour is not saved for an occasion. Our pieces are designed to travel, be worn often and gather stories of their own.",
  },
];

function About() {
  return (
    <main className="about" id="main-content">
      <section className="about__hero" aria-labelledby="about-title">
        <p className="about__eyebrow">About the studio</p>
        <h1 id="about-title">Colour, made to be lived in.</h1>
        <p className="about__intro">
          {siteConfig.brandName} is an independent studio where painting, craft
          and clothing meet in Hong Kong. We create expressive objects for people who dress
          with curiosity.
        </p>
      </section>

      <figure className="about__editorial-image">
        <img
          src="/main/about-studio.jpg"
          alt={`The ${siteConfig.brandName} studio and its creative process`}
          width="1536"
          height="1024"
          decoding="async"
        />
        <figcaption>
          <span>Inside the studio</span>
          <span>Studies in shape, colour and movement</span>
        </figcaption>
      </figure>

      <section className="about__story" aria-labelledby="about-story-title">
        <div className="about__story-heading">
          <p className="about__eyebrow">Our point of view</p>
          <h2 id="about-story-title">The hand leaves the best trace.</h2>
        </div>
        <div className="about__story-copy">
          <p>
            Our collections start with a painted surface. A loose brushstroke,
            a remembered garden or a sun-faded wall becomes a print, then a
            silhouette, and finally something useful and joyful.
          </p>
          <p>
            We favour thoughtful production over constant novelty. That means
            making fewer pieces, refining their construction and celebrating
            the differences that naturally appear in hand-led work.
          </p>
          <p>
            The result is wearable art with an easy spirit: distinctive without
            feeling precious, and designed to stay relevant beyond a single
            season.
          </p>
        </div>
      </section>

      <section className="about__values" aria-label="Studio values">
        {studioValues.map((value) => (
          <article className="about__value" key={value.number}>
            <span aria-hidden="true">{value.number}</span>
            <h3>{value.title}</h3>
            <p>{value.text}</p>
          </article>
        ))}
      </section>

      <section className="about__closing" aria-labelledby="about-closing-title">
        <div>
          <p className="about__eyebrow">Continue the story</p>
          <h2 id="about-closing-title">Find the piece that feels like yours.</h2>
        </div>
        <div className="about__closing-actions">
          <Link to="/shop">Explore the collection</Link>
          <Link to="/contact">Visit or contact the studio</Link>
        </div>
      </section>
    </main>
  );
}

export default About;
